import React from "react";
import TitleComponent from "../../components/TitleComponent";
import ModalInfo from "../../containers/ModalInfo";
import Loader from "../../components/LoaderComponent";
import useTranslation from "../../i18n/useTranslation";

const NoDirections = ({ modalVisibility, modalContent, closeModal }) => {
   const { t } = useTranslation();

   return (
      <div className="hotels__slide">
         <ModalInfo show={modalVisibility} onHide={closeModal}>
            {modalContent}
         </ModalInfo>
         <TitleComponent className="section_title--width-unset">
            {t("scheduler.title")}
         </TitleComponent>
         <Loader show={false} />
         <div className="flex">
            <div
               className="scheduler__container table-responsive width--100"
               style={{ marginTop: 0 }}
            >
               <div className="display_inline-block">
                  <span className="no-table-content">{t("scheduler.noDestinations")}</span>
               </div>
            </div>
         </div>
      </div>
   );
};

export default NoDirections;
